/* eslint-disable */

import axios from "axios";
import { axiosRequest } from "./axios";

export const API_REQUEST_TIMEOUT_MS = Number(process.env.VUE_APP_API_TIMEOUT_MS) || 30000;

export const STORAGE_ACCESS_TOKEN = "acta_access_token";
export const STORAGE_REFRESH_TOKEN = "acta_refresh_token";

export function getApiBaseUrl() {
  return process.env.VUE_APP_API_URL || "";
}

function getLoginPayload(response) {
  if (response == null || typeof response !== "object") {
    return null;
  }
  const nested = response.data;
  if (
    nested != null &&
    typeof nested === "object" &&
    response.access_token === undefined &&
    response.refresh_token === undefined
  ) {
    return nested;
  }
  return response;
}

export function getAuthSessionFromResponse(response) {
  const payload = getLoginPayload(response);
  if (!payload) {
    return { accessToken: null, refreshToken: null };
  }
  const accessToken = payload.access_token ?? payload.accessToken ?? null;
  const refreshToken = payload.refresh_token ?? payload.refreshToken ?? null;
  return { accessToken, refreshToken };
}

export function isLoginSuccess(response) {
  if (!response) return false;
  const payload = getLoginPayload(response);
  if (payload?.status === 200) {
    return true;
  }
  return Boolean(getAuthSessionFromResponse(response).accessToken);
}

export function applyStoredAuthToAxios() {
  const token = sessionStorage.getItem(STORAGE_ACCESS_TOKEN);
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
}

export function clearAuthSession() {
  sessionStorage.removeItem(STORAGE_ACCESS_TOKEN);
  sessionStorage.removeItem(STORAGE_REFRESH_TOKEN);
  applyStoredAuthToAxios();
}

export async function loginUsuario({ username, password }) {
  const loginUrl = "/servicios/login";

  try {
    const response = await axiosRequest(
      loginUrl,
      {
        username,
        password,
      },
      { timeout: API_REQUEST_TIMEOUT_MS }
    );

    if (!isLoginSuccess(response)) {
      const payload = getLoginPayload(response);
      return {
        success: false,
        message:
          payload?.mensaje ||
          payload?.message ||
          response?.mensaje ||
          response?.message ||
          "Credenciales inválidas",
      };
    }

    const { accessToken, refreshToken } = getAuthSessionFromResponse(response);
    if (!accessToken) {
      return {
        success: false,
        message: "Login exitoso, pero la API no devolvió token.",
      };
    }

    const payload = getLoginPayload(response);
    const empleado = payload?.empleado ?? null;
    const sucursales = payload?.sucursales ?? [];

    return {
      success: true,
      token: accessToken,
      refreshToken,
      message: payload?.mensaje || payload?.message || "Login correcto",
      empleado,
      sucursales,
    };
  } catch (error) {
    const data = error?.response?.data;
    const message =
      data?.mensaje || data?.message || error?.message || "No fue posible iniciar sesión";
    return {
      success: false,
      message,
    };
  }
}
